module.exports = __webpack_public_path__ + "img/6f2.3e58cc90.jpg";